import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { toast } from 'sonner';
import { Button, PageHeader } from '../components/ui';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { workspaceService } from '../services/workspaceService';

export default function AcceptWorkspaceInvitationPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshOrganizerContext } = useAdminAuth();
  const [saving, setSaving] = useState(false);
  const token = params.get('token');
  async function accept() {
    if (!token) return;
    setSaving(true);
    try { await workspaceService.acceptInvitation(token); await refreshOrganizerContext(); toast.success('Invitation accepted'); navigate('/workspaces', { replace: true }); }
    catch (error) { toast.error('Could not accept invitation', { description: error instanceof Error ? error.message : 'Unknown error' }); }
    finally { setSaving(false); }
  }
  return <div className="p-8 max-w-2xl"><PageHeader title="Join a workspace" description={token ? 'Accept this invitation to access the organizer workspace.' : 'This invitation link is missing its token.'} />{token && <Button loading={saving} onClick={() => void accept()}>Accept invitation</Button>}</div>;
}
